<template>
  <div class="scheduling-page-container">
    <div class="page-content">
      <!-- 顶部控制栏 -->
      <div class="top-control-bar">
        <div class="greenhouse-select">
          <span style="margin-right: 10px; color: #fff">选择大棚:</span>
          <el-select
            v-model="selectedGreenhouseId"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            @change="handleGreenhouseChange"
          >
            <el-option
              v-for="item in greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- Tab切换 -->
        <div class="tab-menu-box">
          <div
            :class="
              activeTab == 'background' ? 'tab-menu-item died' : 'tab-menu-item'
            "
            @click="handleTabChange('background')"
          >
            定义背景图片
          </div>
          <div
            :class="[
              activeTab == 'device' ? 'tab-menu-item died' : 'tab-menu-item',
              { 'tab-menu-item-disabled': !hasCurrentBackground },
            ]"
            @click="handleTabChange('device')"
          >
            定义设备位置
          </div>
        </div>
      </div>

      <!-- Tab内容 -->
      <div class="tab-content-wrapper">
        <!-- Tab 1: 定义背景图片 -->
        <div v-if="activeTab === 'background'" class="tab-content">
          <!-- 操作栏 -->
          <div class="operation-bar">
            <el-button type="primary" size="mini" @click="handleCreate"
              >+新增</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="handleBatchDelete"
              :disabled="!selectedRows.length"
            >
              删除
            </el-button>
          </div>

          <!-- 数据表格 -->
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            height="60vh"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              label="序号"
              type="index"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="imgName" label="图片名称"></el-table-column>
            <el-table-column label="图片样式" width="120" align="center">
              <template slot-scope="scope">
                <div class="image-preview">
                  <el-image
                    v-if="scope.row.imgUrl || scope.row.imageUrl"
                    :src="getImageUrl(scope.row.imgUrl || scope.row.imageUrl)"
                    :preview-src-list="[
                      getImageUrl(scope.row.imgUrl || scope.row.imageUrl),
                    ]"
                    fit="cover"
                    class="preview-image"
                  >
                  </el-image>
                  <span v-else>暂无图片</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间">
              <template slot-scope="scope">
                {{ formatTime(scope.row.updateTime) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #2680dd"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  style="color: #04ff9f"
                  @click="handleView(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  type="primary"
                  v-if="!scope.row.isDefault"
                  size="mini"
                  @click="handleSetCurrent(scope.row)"
                >
                  设为当前
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>

        <!-- Tab 2: 定义设备位置 -->
        <div
          v-if="activeTab === 'device'"
          class="tab-content device-position-tab"
        >
          <DevicePositionEditor
            :background-image-url="currentBackgroundImageUrl"
            :background-image-id="currentBackgroundImageId"
            :greenhouse-id="selectedGreenhouseId"
            :existing-devices="existingDevicePositions"
            :is-embedded="true"
            @save="handleSaveDevicePositions"
          />
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        label-position="top"
        label-width="120px"
      >
        <el-form-item label="图片名称:" prop="imageName">
          <el-input
            v-model="formData.imageName"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片样式:" prop="imageUrl">
          <div class="image-upload-wrapper">
            <ImageUpload
              v-model="imageUrlArray"
              :maxCount="1"
              accept=".png,.jpg,.jpeg"
              @uploading="handleImageUploading"
            />
            <div class="upload-tips">
              注:此处只可上传一张图片(如需更新,请先删除当前图片),格式为png、jpg,尺寸为1920*1080
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
          :disabled="isImageUploading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="500px">
      <div class="view-detail">
        <p><strong>图片名称：</strong>{{ viewRow.imageName }}</p>
        <p><strong>图片样式：</strong></p>
        <div class="view-image-container">
          <el-image
            v-if="viewRow.imageUrl"
            :src="getImageUrl(viewRow.imageUrl)"
            :preview-src-list="[getImageUrl(viewRow.imageUrl)]"
            fit="contain"
            class="view-image"
          >
          </el-image>
          <span v-else>暂无图片</span>
        </div>
        <p><strong>更新时间：</strong>{{ formatTime(viewRow.updateTime) }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览弹窗 -->
    <el-dialog
      :visible.sync="imagePreviewVisible"
      width="80%"
      center
      :show-close="true"
    >
      <img :src="previewImageUrl" style="width: 100%; height: auto" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl, uploadUrl } from "@/axios/baseUrl";
import DevicePositionEditor from "./DevicePositionEditor.vue";
import ImageUpload from "@/components/ImageUpload.vue";

export default {
  name: "SchedulingPage",
  components: {
    DevicePositionEditor,
    ImageUpload,
  },
  data() {
    return {
      activeTab: "background",
      selectedGreenhouseId: "",
      greenhouseOptions: [],
      tableData: [],
      selectedRows: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      dialogTitle: "新增",
      formData: {
        id: "",
        imageName: "",
        imageUrl: "",
        greenhouseId: "",
      },
      isEdit: false,
      rules: {
        imageName: [
          { required: true, message: "请输入图片名称", trigger: "blur" },
        ],
        imageUrl: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
      },
      viewDialogVisible: false,
      viewRow: {},
      imagePreviewVisible: false,
      previewImageUrl: "",
      uploadUrl: uploadUrl,
      imageFileList: [],
      imageUrlArray: [], // 用于 ImageUpload 组件的数组格式
      isImageUploading: false, // 图片是否正在上传
      // 设备位置编辑相关
      currentBackgroundImageUrl: "",
      currentBackgroundImageId: "",
      existingDevicePositions: [],
    };
  },
  computed: {
    // 判断是否有当前背景
    hasCurrentBackground() {
      if (
        !this.selectedGreenhouseId ||
        !this.tableData ||
        this.tableData.length === 0
      ) {
        return false;
      }
      const currentImage = this.tableData.find((item) => item.isDefault);
      if (!currentImage) return false;
      return Boolean(currentImage.imgUrl || currentImage.imageUrl);
    },
  },
  watch: {
    imageUrlArray: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.formData.imageUrl = newVal[0];
        } else {
          this.formData.imageUrl = "";
        }
        // 触发验证
        this.$refs.formRef && this.$refs.formRef.validateField("imageUrl");
      },
      immediate: false,
    },
  },
  created() {
    this.fetchGreenhouseOptions();
    this.fetchData();
  },
  methods: {
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      try {
        const formData = new FormData();
        formData.append("enableStatus", 1);
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse/selection",
          formData
        );
        if (res.code === 200) {
          this.greenhouseOptions = res.data.map((item) => ({
            label: item.serialNumber,
            value: item.id,
          }));
          // 默认选择第一个
          if (this.greenhouseOptions.length > 0 && !this.selectedGreenhouseId) {
            this.selectedGreenhouseId = this.greenhouseOptions[0].value;
            this.fetchData();
          }
        }
      } catch (error) {
        console.error("获取大棚列表失败:", error);
      }
    },
    // 获取数据列表
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          greenhouseId: this.selectedGreenhouseId,
        };
        // TODO: 替换为实际的API接口
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse-bg/list-page",
          params
        );
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;

          // 如果当前在设备位置tab，更新背景图
          if (this.activeTab === "device") {
            this.updateBackgroundImage();
          }
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        // 模拟数据，实际使用时删除
        this.tableData = [];
        this.totalCount = 0;

        // 如果当前在设备位置tab，设置默认背景图
        if (this.activeTab === "device") {
          this.updateBackgroundImage();
        }
      }
    },
    // 大棚选择变化
    handleGreenhouseChange(value) {
      this.page = 1;
      this.fetchData();
    },
    // Tab切换
    handleTabChange(tabName) {
      // 如果切换到设备位置tab，先检查是否有当前背景
      if (tabName === "device") {
        if (!this.hasCurrentBackground) {
          this.$message.warning("请先设置当前背景图片，才能定义设备位置");
          return;
        }
      }
      this.activeTab = tabName;
      if (tabName === "device") {
        // 切换到设备位置tab时，加载数据
        this.loadDevicePositionData();
      }
    },
    // 更新背景图片
    updateBackgroundImage() {
      // 获取当前背景图片
      const currentImage = this.tableData.find((item) => item.isDefault);
      if (currentImage) {
        const bgUrl = currentImage.imgUrl || currentImage.imageUrl || "";
        this.currentBackgroundImageUrl = bgUrl;
        this.currentBackgroundImageId = currentImage.id;
      } else {
        this.currentBackgroundImageUrl = "";
        this.currentBackgroundImageId = "";
      }
    },
    // 加载设备位置数据
    async loadDevicePositionData() {
      if (!this.selectedGreenhouseId) {
        this.$message.warning("请先选择大棚");
        return;
      }

      // 如果数据还没加载，先加载数据
      if (this.tableData.length === 0) {
        await this.fetchData();
      } else {
        // 如果数据已加载，直接更新背景图
        this.updateBackgroundImage();
      }

      // 获取已保存的设备位置配置
      try {
        const res = await axios.post(
          baseUrl + "/api/device/device-info/list-page",
          {
            page: 1,
            pageSize: 100,
            greenhouseId: this.selectedGreenhouseId,
            deviceType: "MONITORING_DEVICE",
          }
        );
        if (res.code === 200) {
          this.existingDevicePositions = (res.data.list || []).map((item) => {
            const coords = (item.bgXY || "").split(",");
            const imagePrefix = item.onlineStatus ? "e" : "l";
            return {
              id: item.id,
              name: item.name,
              classify: item.classify,
              onlineStatus: item.onlineStatus,
              image: `${imagePrefix}${item.classify}.png`,
              x: coords[0],
              y: coords[1],
            };
          });
        }
      } catch (error) {
        console.error("获取设备位置配置失败:", error);
      }
    },
    // 保存设备位置
    async handleSaveDevicePositions(data) {
      const bgXYList = data.devices.map((item) => {
        return {
          deviceId: item.id,
          bgXY: item.x + "," + item.y,
        };
      });
      try {
        const res = await axios.post(
          baseUrl + "/api/device/device-info/update-bg-xy",
          {
            bgXYList,
          }
        );
        if (res.code === 200) {
          this.$message.success("设备位置保存成功");
          // 重新加载数据
          this.loadDevicePositionData();
        } else {
          this.$message.error(res.message || "保存失败");
        }
      } catch (error) {
        console.error("保存设备位置失败:", error);
        this.$message.error("保存失败");
      }
    },
    // 选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    // 新增
    handleCreate() {
      if (!this.selectedGreenhouseId) {
        this.$message.warning("请先选择大棚");
        return;
      }
      this.isEdit = false;
      this.dialogTitle = "新增";
      this.dialogVisible = true;
      this.isImageUploading = false;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        this.formData = {
          id: "",
          imageName: "",
          imageUrl: "",
          greenhouseId: this.selectedGreenhouseId,
        };
        this.imageFileList = [];
        this.imageUrlArray = [];
      });
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑";
      this.dialogVisible = true;
      this.isImageUploading = false;
      this.$nextTick(async () => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        try {
          // 使用详情接口获取最新数据，解决字段命名不一致问题
          const res = await axios.post(
            baseUrl + "/api/basic/greenhouse-bg/detail/" + row.id
          );
          if (res && res.code === 200 && res.data) {
            const detail = res.data;
            const imageName = detail.imgName || detail.imageName || "";
            const imageUrl = detail.imgUrl || detail.imageUrl || "";
            this.formData = {
              id: detail.id || row.id,
              imageName,
              imageUrl,
              greenhouseId: this.selectedGreenhouseId,
              isDefault: detail.isDefault || row.isDefault || false,
            };
            // 设置图片URL数组（用于 ImageUpload 组件）
            this.imageUrlArray = imageUrl ? [imageUrl] : [];
            // 兼容旧的文件列表显示
            this.imageFileList = imageUrl
              ? [
                  {
                    name: imageName || "图片",
                    url: this.getImageUrl(imageUrl),
                    uid: Date.now(),
                  },
                ]
              : [];
          } else {
            // 接口异常时，回退到行数据（尽量兼容字段）
            const imageName = row.imageName || row.imgName || "";
            const imageUrl = row.imageUrl || row.imgUrl || "";
            this.formData = {
              id: row.id,
              imageName,
              imageUrl,
              greenhouseId: this.selectedGreenhouseId,
              isDefault: row.isDefault || false,
            };
            this.imageUrlArray = imageUrl ? [imageUrl] : [];
            this.imageFileList = imageUrl
              ? [
                  {
                    name: imageName || "图片",
                    url: this.getImageUrl(imageUrl),
                    uid: Date.now(),
                  },
                ]
              : [];
          }
        } catch (e) {
          console.error("获取背景图详情失败:", e);
          // 出错时也做回退
          const imageName = row.imageName || row.imgName || "";
          const imageUrl = row.imageUrl || row.imgUrl || "";
          this.formData = {
            id: row.id,
            imageName,
            imageUrl,
            greenhouseId: this.selectedGreenhouseId,
            isDefault: row.isDefault || false,
          };
          this.imageUrlArray = imageUrl ? [imageUrl] : [];
          this.imageFileList = imageUrl
            ? [
                {
                  name: imageName || "图片",
                  url: this.getImageUrl(imageUrl),
                  uid: Date.now(),
                },
              ]
            : [];
        }
      });
    },
    // 查看
    handleView(row) {
      // 先展示弹窗，再拉取详情填充，避免空白等待
      this.viewRow = { ...row };
      this.viewDialogVisible = true;
      this.$nextTick(async () => {
        try {
          const res = await axios.post(
            baseUrl + "/api/basic/greenhouse-bg/detail/" + row.id
          );
          if (res && res.code === 200 && res.data) {
            const detail = res.data;
            this.viewRow = {
              ...this.viewRow,
              id: detail.id || row.id,
              imageName: detail.imgName || detail.imageName || "",
              imageUrl: detail.imgUrl || detail.imageUrl || "",
              updateTime: detail.updateTime || row.updateTime,
              isDefault: detail.isDefault ?? row.isDefault,
            };
          }
        } catch (e) {
          console.error("获取背景图详情失败(查看):", e);
        }
      });
    },
    // 查看图片
    handleViewImage(row) {
      if (row.imageUrl) {
        this.previewImageUrl = this.getImageUrl(row.imageUrl);
        this.imagePreviewVisible = true;
      }
    },
    // 设为当前
    async handleSetCurrent(row) {
      try {
        await this.$confirm(
          `确认将 "${row.imgName}" 设为当前背景图片吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        // TODO: 替换为实际的API接口
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse-bg/set-default/" + row.id
        );
        if (res.code === 200) {
          this.$message.success("设置成功");
          this.fetchData();
          // 如果当前在设备位置tab，重新加载数据
          if (this.activeTab === "device") {
            this.loadDevicePositionData();
          }
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("设置失败:", error);
        }
      }
    },
    // 图片上传状态变化
    handleImageUploading(uploading) {
      this.isImageUploading = uploading;
    },
    // 弹窗关闭
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.isEdit = false;
      this.formData = {
        id: "",
        imageName: "",
        imageUrl: "",
        greenhouseId: "",
      };
      this.imageFileList = [];
      this.imageUrlArray = [];
      this.isImageUploading = false;
    },
    // 提交
    async handleSubmit() {
      // 如果图片正在上传，不允许提交
      if (this.isImageUploading) {
        this.$message.warning("图片正在上传中，请稍候...");
        return;
      }

      // 从 imageUrlArray 中获取图片URL（取第一个）
      if (this.imageUrlArray && this.imageUrlArray.length > 0) {
        this.formData.imageUrl = this.imageUrlArray[0];
      } else {
        this.formData.imageUrl = "";
      }

      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            let url = "/api/basic/greenhouse-bg/add";
            if (this.isEdit) {
              url = "/api/basic/greenhouse-bg/edit";
            }

            // 构建提交数据，转换字段名
            const submitData = {
              greenhouseId: this.selectedGreenhouseId,
              imgName: this.formData.imageName,
              imageName: this.formData.imageName,
              imgUrl: this.formData.imageUrl,
              imageUrl: this.formData.imageUrl,
            };

            // 编辑时需要添加 id
            if (this.isEdit && this.formData.id) {
              submitData.id = this.formData.id;
            }

            // 设置 isDefault：编辑时根据 isDefault 判断，新增时默认为 false
            if (this.isEdit) {
              submitData.isDefault = this.formData.isDefault || false;
            } else {
              submitData.isDefault = false;
            }

            const res = await axios.post(baseUrl + url, submitData);
            if (res.code === 200) {
              this.$message.success(this.isEdit ? "更新成功" : "新增成功");
              this.dialogVisible = false;
              this.fetchData();
            }
          } catch (error) {
            console.error("提交失败:", error);
          }
        }
      });
    },
    // 批量删除
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedRows.length} 个配置吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const ids = this.selectedRows.map((row) => row.id);
        // TODO: 替换为实际的API接口
        const res = await axios.post(
          baseUrl + "/api/basic/greenhouse-bg/delete-batch",
          ids
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/\//g, "/");
    },
    // 获取图片URL
    getImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      return baseUrl + url;
    },
  },
};
</script>

<style scoped lang="less">
.scheduling-page-container {
  .page-content {
    background: rgba(0, 11, 47, 0.3);
    border-radius: 4px;

    .top-control-bar {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      .greenhouse-select {
        display: flex;
        align-items: center;
      }

      .control-buttons {
        display: flex;
        gap: 10px;
      }
    }

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }

    .tab-menu-box {
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 10px;

      .tab-menu-item {
        padding: 10px 20px;
        color: #fff;
        font-size: 22px;
        cursor: pointer;
        background-image: url("../../../assets/img/data/btn.png");
        background-size: 100% 100%;
        margin-right: 10px;
      }

      .died {
        background-image: url("../../../assets/img/data/btned.png");
      }

      .tab-menu-item-disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .tab-content-wrapper {
      margin: 10px 0;
    }

    .tab-content {
      &.device-position-tab {
        height: calc(100vh - 300px);
        min-height: 600px;
      }
    }

    .image-preview {
      .preview-image {
        width: 80px;
        height: 60px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        cursor: pointer;

        ::v-deep .el-image__inner {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &:hover {
          border-color: #409eff;
        }
      }
    }
  }

  .image-upload-wrapper {
    .single-image-uploader {
      ::v-deep .el-upload--picture-card {
        width: 148px;
        height: 148px;
        line-height: 148px;
      }

      ::v-deep .el-upload-list--picture-card {
        .el-upload-list__item {
          width: 148px;
          height: 148px;
        }
      }
    }

    .upload-tips {
      margin-top: 10px;
      font-size: 12px;
      color: #909399;
      line-height: 1.5;
    }
  }

  .view-detail {
    p {
      margin-bottom: 15px;
      line-height: 1.8;

      strong {
        color: #303133;
        margin-right: 10px;
      }
    }

    .view-image-container {
      margin: 10px 0;
      text-align: center;

      .view-image {
        max-width: 100%;
        max-height: 400px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
